import React from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

interface ContentBoxProps {
  children: React.ReactNode;
}

const ContentBox: React.FC<ContentBoxProps> = ({ children }) => {
  const bgGradient = useColorModeValue(
    "linear(to-br, white, #f5f9f9, #eef5f5)",
    "linear(to-br, gray.800, gray.700)"
  );

  return (
    <MotionBox
      mb={8}
      mt={{ base: 0, md: 0 }}
      p={{ base: 4, md: 8 }}
      bgGradient={bgGradient}
      borderRadius="2xl"
      boxShadow="lg"
      width="100%"
      mx="auto"
      minH="515px"
      h="fit-content"
      position="relative"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </MotionBox>
  );
};

export default ContentBox;
